import { css } from '@emotion/react'
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap'
import { memo } from 'react'
import IconButton from './IconButton'

const buttonStyles = css({
    padding: 7,
})

interface FullWindowButtonProps {
    onClick(event?: any): void
}

const ButtonFullWindowExit = memo(({ onClick }: FullWindowButtonProps) => (
    <IconButton title="Exit Full Screen" onClick={onClick} css={buttonStyles}>
        <ZoomOutMapIcon />
    </IconButton>
))

export default ButtonFullWindowExit
